import React from "react";
import { FiX } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatPeriodDisplay } from "../../uti";
import themeLarge from "../ThemeLarge";

class ProjectEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project || {
        name: "",
        description: "",
        keywords: [],
        github: "",
        blog: "",
        deploy: "",
        period: { from: "", to: "" },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.project?.id !== this.props.project?.id) {
      this.setState({
        project: this.props.project || {
          name: "",
          description: "",
          keywords: [],
          github: "",
          blog: "",
          deploy: "",
          period: { from: "", to: "" },
        },
      });
    }
  }

  updateField = (field, value) => {
    this.setState((prev) => ({
      project: {
        ...prev.project,
        [field]:
          field === "keywords" ? value.split(",").map((k) => k.trim()) : value,
      },
    }));
  };

  updatePeriod = (side, value) => {
    this.setState((prev) => ({
      project: {
        ...prev.project,
        period: {
          ...prev.project.period,
          [side]: value,
        },
      },
    }));
  };

  formatToMMYYYY = (date) => {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}${yyyy}`;
  };

  formatPeriodDate = (str) => {
    if (!str) return null;
    const month = parseInt(str.slice(0, 2)) - 1;
    const year = parseInt(str.slice(2));
    return new Date(year, month);
  };

  handleSubmit = (status) => {
    this.props.onSubmit(this.state.project, status);
  };

  render() {
    const { project } = this.state;
    const { isEditing, onClose } = this.props;

    return (
      <div
        className={`project-detail-view fade-in`}
        style={{
          background: themeLarge.colors.secondary,
          padding: "20px",
          position: "relative",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <FiX
          size={22}
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            cursor: "pointer",
          }}
          onClick={onClose}
        />

        <p style={{ fontSize: themeLarge.fontSize.h3 }}>
          {isEditing ? `Edit Project: ${project.name}` : "Add New Project"}
        </p>

        {/* Inputs */}
        <label>Name:</label>
        <input
          type="text"
          value={project.name}
          onChange={(e) => this.updateField("name", e.target.value)}
          className="form-control"
        />

        <label>Description:</label>
        <textarea
          value={project.description}
          onChange={(e) => this.updateField("description", e.target.value)}
          className="form-control"
          style={{ height: "150px" }}
        />

        <label>Keywords (comma-separated, max 5):</label>
        <input
          type="text"
          value={project.keywords.join(", ")}
          onChange={(e) => this.updateField("keywords", e.target.value)}
          className="form-control"
        />

        <label>Project Period:</label>
        <div className="d-flex align-items-center gap-2">
          <span>From</span>
          <DatePicker
            selected={this.formatPeriodDate(project.period.from)}
            onChange={(date) =>
              this.updatePeriod("from", this.formatToMMYYYY(date))
            }
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="form-control"
            placeholderText="Select Month"
          />
          <span>to</span>
          <DatePicker
            selected={this.formatPeriodDate(project.period.to)}
            onChange={(date) =>
              this.updatePeriod("to", this.formatToMMYYYY(date))
            }
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="form-control"
            placeholderText="Select Month"
          />
        </div>

        <label>GitHub URL:</label>
        <input
          type="url"
          value={project.github}
          onChange={(e) => this.updateField("github", e.target.value)}
          className="form-control"
        />

        <label>Blog URL:</label>
        <input
          type="url"
          value={project.blog}
          onChange={(e) => this.updateField("blog", e.target.value)}
          className="form-control"
        />

        <label>Deploy URL:</label>
        <input
          type="url"
          value={project.deploy}
          onChange={(e) => this.updateField("deploy", e.target.value)}
          className="form-control"
        />

        <div className="mt-3 d-flex gap-2">
          <button
            onClick={() => this.handleSubmit("published")}
            className="btn"
            style={{
              background: themeLarge.colors.primary,
              color: themeLarge.colors.secondary,
            }}
          >
            {isEditing ? "Update Project" : "Create Project"}
          </button>

          <button
            onClick={() => this.handleSubmit("hidden")}
            className="btn btn-secondary"
            style={{
              background: themeLarge.colors.hover,
              color: themeLarge.colors.secondary,
            }}
          >
            {isEditing ? "Hide Project" : "Save as Hidden"}
          </button>
        </div>
      </div>
    );
  }
}

export default ProjectEditor;
